export class Receita{
    constructor(nome,valor){
        this.id = crypto.randomUUID();
        this.nome = nome;
        this.valor = valor  
    }
}